






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ContainImage extends Vue {
  @Prop()
  imageSrc!: string;
  @Prop({ default: false })
  padding!: boolean;
  @Prop({ default: true })
  eager!: boolean;
}
